import { render } from "./About.vue?vue&type=template&id=ff9f67c4&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=ff9f67c4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ff9f67c4"

export default script